import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { PermissionsProvider } from './context/PermissionsContext';
import { ToastContainer } from './components/common/Toast';
import AppShell from './components/layout/AppShell';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import Properties from './pages/Properties';
import Apartments from './pages/Apartments';
import Payments from './pages/Payments';
import WorkOrders from './pages/WorkOrders';
import Leases from './pages/Leases';
import Inventory from './pages/Inventory';
import Notifications from './pages/Notifications';
import Users from './pages/Users';
import Documents from './pages/Documents';
import Tenants from './pages/Tenants';
import RolePermissions from './pages/RolePermissions';
import Expenses from './pages/Expenses';
import Budget from './pages/Budget';
import VerifyReceipt from './pages/VerifyReceipt';
import Settings from './pages/Settings';
import './i18n/i18n';

function PrivateRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="loading-screen">
      <div className="spinner" />
      <span style={{ color:'var(--ink-40)', fontSize:14, marginTop:8 }}>Loading…</span>
    </div>
  );
  return user ? children : <Navigate to="/login" replace />;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="loading-screen"><div className="spinner" /></div>;
  return user ? <Navigate to="/" replace /> : children;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <PermissionsProvider>
        <ToastContainer />
        <Routes>
          <Route path="/login"    element={<PublicRoute><Login /></PublicRoute>} />
          <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
          <Route path="/verify"   element={<VerifyReceipt />} />
          <Route path="/*" element={
            <PrivateRoute>
              <AppShell>
                <Routes>
                  <Route path="/"              element={<Dashboard />} />
                  <Route path="/properties"    element={<Properties />} />
                  <Route path="/apartments"    element={<Apartments />} />
                  <Route path="/payments"      element={<Payments />} />
                  <Route path="/work-orders"   element={<WorkOrders />} />
                  <Route path="/leases"        element={<Leases />} />
                  <Route path="/inventory"     element={<Inventory />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route path="/users"         element={<Users />} />
                  <Route path="/documents"    element={<Documents />} />
                  <Route path="/tenants"          element={<Tenants />} />
                  <Route path="/role-permissions" element={<RolePermissions />} />
                  <Route path="/expenses"         element={<Expenses />} />
                  <Route path="/budget"           element={<Budget />} />
                  <Route path="/settings"         element={<Settings />} />
                  <Route path="*"                 element={<Navigate to="/" replace />} />
                </Routes>
              </AppShell>
            </PrivateRoute>
          } />
        </Routes>
        </PermissionsProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
